import { ElementRef } from '@angular/core';
import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';

export interface EmployeeList {
  material: string;
  code : string;
  category : string;
  required : number;
  stock : number;
  incoming : number;
  WIP : number;
  unplanned : number;
  unit : string;
  leadtime : string;
  mark : any;
 }
 

 const ELEMENT_DATA: EmployeeList[] = [
  {material: '0.37 GAL. FINE WIRE', code: '0.37 GAL. FINE WIRE',category :  'ABCD',required: 2000000,stock : 5,
  incoming :4,WIP:3,unplanned : 30000,unit : 'kg',leadtime :'1',mark: 545 },
  {material: '0.39 MM NON GAL FI WIRES', code: '0.39 MM NON GAL FI WIRES',category : 'ABCD',required: 554,stock : 515,
  incoming :8,WIP:0,unplanned : 69,unit :  'kg',leadtime :'2',mark: 545},
  {material: 'umang patel', code: '134F2972',category : 'ABCD',required: 25,stock : 56,
  incoming :6,WIP:0,unplanned : 7,unit :  'kg',leadtime :'15',mark: 545},
  {material: 'umang patel', code: '01001301M001_RevG',category : 'FC-301P5KT4E20H2BGC',required: 12,stock : 2,
  incoming :9,WIP:0,unplanned : 6,unit :  'kg',leadtime :'15',mark: 545},
  {material: '01001301M001_RevG', code: '01-514 new',category : 'FC-301P5KT4E20H2BGC',required: 85,stock : 68,
  incoming :23,WIP:0,unplanned : 5,unit : 'pices',leadtime :'15',mark: 545},
  {material: '0.37 GAL. FINE WIRE', code: '1 Ltr Bottle - W. Macromix',category : '100 GM Natural',required: 2000,stock : 42,
  incoming :1,WIP:0,unplanned : 300,unit :  'pices',leadtime :'5',mark: 545},
  {material: '01-514 new', code:  '0.39 MM NON GAL FI WIRES',category : 'Scope SW',required: 2200,stock : 1,
  incoming :58,WIP:0,unplanned : 253,unit :  'pices',leadtime :'1',mark: 545},
  {material: '0.37 GAL. FINE WIRE', code: '0.37 GAL. FINE WIRE',category : 'ABCD',required: 54,stock : 2,
  incoming :5,WIP:0,unplanned : 3,unit :  'pices',leadtime :'10',mark: 545},
  {material: '01-514 new', code:  '0.39 MM NON GAL FI WIRES',category : 'ABCD',required: 9,stock : 5,
  incoming :9,WIP:2000,unplanned : 78,unit : 'kg',leadtime :'1',mark: 545},
  {material: '01-514 new', code: '0.37 GAL. FINE WIRE',category : 'Scope SW',required: 4,stock : 2,
  incoming :3,WIP:300,unplanned : 58,unit : 'kg',leadtime : '15',mark: 545},
];


@Component({
  selector: 'app-purchase-planning',
  templateUrl: './purchase-planning.component.html',
  styleUrls: ['./purchase-planning.component.scss']
})
export class PurchasePlanningComponent implements OnInit {


  displayedColumns: string[] = ['material','code','category','required','stock','incoming','WIP','unplanned','unit','leadtime','mark'];
  dataSource = new MatTableDataSource<EmployeeList>(ELEMENT_DATA);
 
  @ViewChild('purchaseprtable', { static: false }) purchaseprtable!: ElementRef;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) 
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
  }
  
  refresh() {
    window.location.reload();
  }

  exportToExcel() {
    const ws: xlsx.WorkSheet =
      xlsx.utils.table_to_sheet(this.purchaseprtable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
  
    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'PurchasePlanningReport.xlsx');
  }

  backBtn() {
    this.router.navigate(['/Stock']);
  }

}
